/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { slug } from '../../common';
import Component, { type ComponentAttrs } from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import type Mithril from 'mithril';

export interface SignUpAlertBodyAttrs extends ComponentAttrs {
	dismiss: () => void;
}

export default class SignUpAlertBody extends Component<SignUpAlertBodyAttrs> {
	oninit(vnode: Mithril.Vnode<SignUpAlertBodyAttrs, this>) {
		super.oninit(vnode);

		// Each time this component is rendered, we want to save a visit to the
		// local storage.
		const key = `${slug}.sign_up_alert.count`;
		localStorage.setItem(key, String((parseInt(localStorage.getItem(key) ?? '') || 0) + 1));
	}

	view(): Mithril.Children {
		return (
			<div className="SignUpAlertBody">
				<div className="SignUpAlertBody-motivation">
					{app.translator.trans('glowingblue-orell-thalia-common.forum.sign_up_alert.motivation_text')}
				</div>
				<div className="SignUpAlertBody-motivation--mobile">
					{app.translator.trans('glowingblue-orell-thalia-common.forum.sign_up_alert.motivation_text_mobile')}
				</div>
				<div className="SignUpAlertBody-action">
					<Button className="Button Button--link" onclick={this.handleRegisterClick.bind(this)}>
						{app.translator.trans('glowingblue-orell-thalia-common.forum.sign_up_alert.register')}
					</Button>
				</div>
			</div>
		);
	}

	handleRegisterClick() {
		const { dismiss } = this.attrs;
		app.modal.show(SignUpModal);
		dismiss();
	}
}
